<template>
  <base-stripe
    :successRedirectURL="'/make-appointment/payment/success'"
    :failedRedirectURL="'/make-appointment/payment/failed'"/>
</template>

<script>
import BaseStripe from "@/views/PaymentGateway/BaseStripe";

export default {
  name: "StripePayment",
  components: {
    BaseStripe,
  },
};
</script>
